// Button fill like pickleplay.vn: on hover the fill rises from the bottom; on leave it keeps rising
// and exits through the top (lc-btn-leave), then snaps back below the button without a transition.
// Header state: html.lc-header-scrolled once the page has scrolled (homepage header turns from dark to white).
(() => {
  const root = document.documentElement;
  const update = () => root.classList.toggle('lc-header-scrolled', window.scrollY > 8);
  update();
  window.addEventListener('scroll', update, { passive: true });
})();

(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const SELECTOR = '.button-primary, .button-secondary, .anm-button-primary, .anm-button-secondary';
  const timers = new WeakMap();
  document.addEventListener('pointerover', (event) => {
    const button = event.target.closest?.(SELECTOR);
    if (!button) return;
    clearTimeout(timers.get(button));
    button.classList.remove('lc-btn-leave');
  }, { passive: true });
  document.addEventListener('pointerout', (event) => {
    const button = event.target.closest?.(SELECTOR);
    if (!button || button.contains(event.relatedTarget)) return;
    button.classList.add('lc-btn-leave');
    timers.set(button, setTimeout(() => button.classList.remove('lc-btn-leave'), 550));
  }, { passive: true });
})();

// Nav labels: the hover pill (a ::after copy, as on pickleplay.vn) reads its text from data-lc-label.
(() => {
  document.querySelectorAll('.x-header li.main-menu-item > a, .x-header li.main-menu-item > div > a').forEach((link) => {
    const label = link.querySelector('span');
    link.dataset.lcLabel = (label ? label.textContent : link.textContent).replace(/\s+/g, ' ').trim();
  });
})();
